import { createContext, useState } from "react";
import RadiologyTable from "./components/RadiologyTable";
import { InvestigationFormType, RadiologyTableType } from "../types";

export type contextType = {
  tableData: RadiologyTableType[];
  setTableData: (params: RadiologyTableType[]) => void;
  edit: InvestigationFormType | null;
  setEdit: (params: any) => void;
  refetchRadiology: boolean;
  setRefechRadiology: (param: boolean) => void;
};

export const RadiologyContext = createContext<contextType>({
  edit: null,
  setEdit: () => {},
  tableData: [],
  setTableData: () => {},
  refetchRadiology: true,
  setRefechRadiology: () => {},
});

function Radiology() {
  const [tableData, setTableData] = useState<RadiologyTableType[]>([]);
  const [edit, setEdit] = useState<null>(null);
  const [refetchRadiology, setRefechRadiology] = useState(true);

  return (
    <RadiologyContext.Provider
      value={{
        tableData,
        setTableData,
        edit,
        setEdit,
        refetchRadiology,
        setRefechRadiology,
      }}
    >
      <RadiologyTable />
    </RadiologyContext.Provider>
  );
}

export default Radiology;
